module.exports = __webpack_public_path__ + "img/astral_1.a3a4b576.svg";